import { Fragment, useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import DeviceDealerList from "./deviceDealersList";
import { getCountryCodeISO } from "../../utils/general";
import {
  getDeviceDealerInfoByPSN,
  getDeviceDealerInfoByDealerId,
} from "../../action/deviceDealer";
import DisplayDeviceDealerDeatils from "./deviceDealerDetailsPage";
import Alert from "../layout/Alert";
import customConfig from "../../config";
import "../Common/searchFilterLayout.css";
import { Box, Paper } from "@mui/material";
import FormInput from "../Common/FormInputs/MuiTextField";
import Button from "../Common/Button/Button";
import { SectionHeading } from "../Common/Typography/AppTypography";
import SearchIcon from "@mui/icons-material/Search";
import { selectMenuProps } from "../../utils/selectMenuProps";

const GetDealerInfo = ({
  allowedCountries,
  setAlert,
  onEditDeviceDealerDetails,
  showUpdatedDealerInfo,
  userRoleInfo,
}) => {
  const [dealerSearchBy, setDealerSearchBy] = useState("dealerId");
  const [dealerSearchByID, setDealerSearchByID] = useState("");
  const [searchButtonClicked, setSearchButtonClicked] = useState("");
  const [dealerSearchByCountry, setDealerSearchByCountry] = useState("");
  const [dealerSearchByPSN, setDealerSearchByPSN] = useState("");

  const [deviceDealerInfo, setDeviceDealerInfo] = useState({});

  useEffect(() => {
    setDeviceDealerInfo({});
  }, [
    dealerSearchBy,
    dealerSearchByCountry,
    dealerSearchByID,
    dealerSearchByPSN,
    searchButtonClicked,
  ]);

  useEffect(() => {
    if (showUpdatedDealerInfo) {
      setDeviceDealerInfo({});
    }
  }, [showUpdatedDealerInfo]);

  function handleEditDeviceDealerDetails(deviceDealerDetails) {
    onEditDeviceDealerDetails(deviceDealerDetails);
  }

  function handleSearchButtonClicked() {
    setSearchButtonClicked(true);

    if (dealerSearchBy === "productSerialNumber") {
      if (dealerSearchByPSN && dealerSearchByPSN.length !== 0) {
        getDeviceDealerInfoByPSN(dealerSearchByPSN)
          .then((data) => {
            setDeviceDealerInfo(data);
          })
          .catch((err) => {
            setAlert(
              err?.response?.data?.message ?? "Failed to Get Dealer Details",
              "danger",
            );
          });
      } else {
        setAlert("Invalid Product Serial Number", "danger");
      }
    } else if (dealerSearchBy === "dealerId") {
      if (dealerSearchByID && dealerSearchByID.length !== 0) {
        getDeviceDealerInfoByDealerId(dealerSearchByID)
          .then((data) => {
            setDeviceDealerInfo(data);
          })
          .catch((err) => {
            setAlert(
              err?.response?.data?.message ?? "Failed to Get Dealer Details",
              "danger",
            );
          });
      } else {
        setAlert("Invalid Dealer ID", "danger");
      }
    } else {
      // search is by country.. there we have to display the dealer list instead of single dealer
      if (
        !dealerSearchByCountry ||
        (dealerSearchByCountry && dealerSearchByCountry === "Select Country") ||
        (dealerSearchByCountry && dealerSearchByCountry.length === 0)
      ) {
        setAlert("Invalid Country", "danger");
      }
    }
  }

  function handleDeleteDeviceDealerDetails() {
    setDeviceDealerInfo({});
  }

  return (
    <Fragment>
      <Alert />
      <Paper sx={{ p: 2.5, pt: 3, pb: 3, borderRadius: 2 }} elevation={3}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 12, md: 3, lg: 2 }}>
            <SectionHeading sx={{ pt: 1, mb: 0 }}>
              Search Device Dealer
            </SectionHeading>
          </Grid>

          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            <FormInput
              name="dealerSearchBy"
              type="select"
              label="Search By"
              value={dealerSearchBy}
              onChange={(e) => {
                setSearchButtonClicked(false);
                setDealerSearchBy(e.target.value);
              }}
              options={[
                { label: "Dealer Id", value: "dealerId" },
                {
                  label: "Product Serial Number",
                  value: "productSerialNumber",
                },
                { label: "Country", value: "dealerCountry" },
              ]}
              MenuProps={selectMenuProps}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 4, md: 3 }}>
            {dealerSearchBy === "dealerId" && (
              <FormInput
                name="dealerSearchField"
                label="Dealer Id"
                placeholder={"Enter Dealer Id"}
                value={dealerSearchByID}
                onChange={(e) => {
                  setDealerSearchByID(e.target.value);
                  setSearchButtonClicked(false);
                }}
                startAdornment={<SearchIcon fontSize="small" />}
              />
            )}
            {dealerSearchBy === "productSerialNumber" && (
              <FormInput
                name="dealerSearchField"
                label="Product Serial Number"
                placeholder={"Enter Product Serial Number"}
                value={dealerSearchByPSN}
                onChange={(e) => {
                  setDealerSearchByPSN(e.target.value);
                  setSearchButtonClicked(false);
                }}
                startAdornment={<SearchIcon fontSize="small" />}
              />
            )}
            {dealerSearchBy === "dealerCountry" && (
              <FormInput
                type="select"
                label="Select Country"
                value={dealerSearchByCountry}
                onChange={(e) => {
                  setDealerSearchByCountry(e.target.value);
                  setSearchButtonClicked(false);
                }}
                options={[
                  ...allowedCountries
                    .filter((c) => getCountryCodeISO(c.toUpperCase()))
                    .map((c) => ({
                      label: getCountryCodeISO(c.toUpperCase()),
                      value: getCountryCodeISO(c.toUpperCase()),
                    })),
                ]}
                MenuProps={selectMenuProps}
              />
            )}
          </Grid>

          <Grid size={{ xs: 12, sm: 3, md: 1, lg: 1 }}>
            <Button onClick={handleSearchButtonClicked}>Search</Button>
          </Grid>
        </Grid>
      </Paper>

      <Box>
        {searchButtonClicked &&
          dealerSearchBy === "dealerCountry" &&
          dealerSearchByCountry &&
          dealerSearchByCountry !== "Select Country" &&
          dealerSearchByCountry.length > 0 && (
            <DeviceDealerList
              countryCodeFilter={dealerSearchByCountry}
              setAlert={setAlert}
              onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
              showUpdatedDealerInfo={showUpdatedDealerInfo}
              userRoleInfo={userRoleInfo}
            />
          )}

        {searchButtonClicked &&
          dealerSearchBy === "productSerialNumber" &&
          dealerSearchByPSN &&
          Object.keys(deviceDealerInfo).length > 0 && (
            <DisplayDeviceDealerDeatils
              deviceDealerDetails={deviceDealerInfo}
              displayEditDeleteButton={
                userRoleInfo.level > 4 ||
                userRoleInfo.roles.includes(customConfig.roleCloudAdmin)
              }
              onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
              showUpdatedDealerInfo={showUpdatedDealerInfo}
              onDeleteDeviceDealerDetails={handleDeleteDeviceDealerDetails}
              setAlert={setAlert}
            />
          )}

        {searchButtonClicked &&
          dealerSearchBy === "dealerId" &&
          dealerSearchByID &&
          Object.keys(deviceDealerInfo).length > 0 && (
            <DisplayDeviceDealerDeatils
              deviceDealerDetails={deviceDealerInfo}
              displayEditDeleteButton={
                userRoleInfo.level > 4 ||
                userRoleInfo.roles.includes(customConfig.roleCloudAdmin)
              }
              onEditDeviceDealerDetails={handleEditDeviceDealerDetails}
              onDeleteDeviceDealerDetails={handleDeleteDeviceDealerDetails}
              setAlert={setAlert}
            />
          )}
      </Box>
    </Fragment>
  );
};

export default GetDealerInfo;
